
import { GenericEntityMetadata, PropertyMetadata, nullIfContainsNull } from '@scisys-uim/uim-common';


export class RefCodeMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('RefCode', {
      code: <PropertyMetadata> {
        name: 'code',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 64,
        unique: false
      },
      domain: <PropertyMetadata> {
        name: 'domain',
        type: 'string',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 64,
        unique: false
      },
      meaning: <PropertyMetadata> {
        name: 'meaning',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      val1: <PropertyMetadata> {
        name: 'val1',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 32,
        unique: false
      },
      val2: <PropertyMetadata> {
        name: 'val2',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 32,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = {
      code: item?.code,
      domain: item?.domain
    };
    return nullIfContainsNull(result);
  }
}



